<template>
  <div>
    <Layout/>
    <h4>Sesiones</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idSesion" class="form-label">IdSesion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idSesion" name="idSesion" v-model="datoSesion.idSesion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoSesion.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoSesion.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccionIp" class="form-label">DireccionIp</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="direccionIp" name="direccionIp" v-model="datoSesion.direccionIp" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="userAgent" class="form-label">UserAgent</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="userAgent" name="userAgent" v-model="datoSesion.userAgent" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarSesion" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarSesion" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditSesion" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAccesoSesion</th>
          <th scope="col">IdModuUsua</th>
          <th scope="col">IdSesion</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
          <th scope="col">SesionFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="accesosesion in datosPaginados" :key="accesosesion.idAccesoSesion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(accesosesion.idAccesoSesion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(accesosesion.idAccesoSesion)" title="Editar">edit_square</i></td>
          <td>{{accesosesion.idAccesoSesion}}</td>
          <td>{{accesosesion.idModuUsua}}</td>
          <td>{{accesosesion.idSesion}}</td>
          <td>{{getFormattedDate(accesosesion.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{accesosesion.estado}}</td>
          <td>{{getFormattedDate(accesosesion.sesionFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteSesion(accesosesion.idAccesoSesion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAccesoSesion" class="form-label">IdAccesoSesion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAccesoSesion" name="idAccesoSesion" v-model="datoAccesoSesion.idAccesoSesion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idModuUsua" name="idModuUsua" v-model="datoAccesoSesion.idModuUsua"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idModuUsua" class="form-label"> Modu Usua</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="moduUsua" name="moduUsua" v-model="datoAccesoSesion.moduUsua" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalModuUsuaLOV"
                      title="Buscar Módulos por usuarios">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idSesion" class="form-label">IdSesion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idSesion" name="idSesion" v-model="datoAccesoSesion.idSesion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAccesoSesion.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAccesoSesion" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAccesoSesion" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: AccesoSesion -->
    <AccesoSesionLOVdet @DatosAccesoSesion="GetDataAccesoSesionLOVdet($event)"/>
<!-- Lista de Valores: ModuUsua -->
    <ModuUsuaLOVdet @DatosModuUsua="GetDataModuUsuaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
// Listas de valores master
// Listas de valores details
import AccesoSesionLOVdet from '../../components/lovs/AccesoSesionLOV.vue'
import ModuUsuaLOVdet from '../../components/lovs/ModuUsuaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, AccesoSesionLOVdet
, ModuUsuaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      sesions : [],
      datoSesion : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idSesion: '',
// Variables master
// Variables details
      accesosesions : [],
      datoAccesoSesion : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idSesion = this.$route.params.p_idsesion
    this.abrirEditar(this.p_idSesion)
    this.getAccesoSesions()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoSesion.idSesion === ''){
        swal("Error!", "El elemento idSesion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSesion.idUsuario === ''){
        swal("Error!", "El elemento idUsuario no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSesion.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSesion.direccionIp === ''){
        swal("Error!", "El elemento direccionIp no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSesion.userAgent === ''){
        swal("Error!", "El elemento userAgent no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSesion.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarSesion(){
      if(this.validarForm() === 1){
        try {
          this.datoSesion.idUsuario = window.sessionStorage.getItem("idUsuario");
          await api.post('/sesions', this.datoSesion)
          swal("Correcto!", "Sesion creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditSesion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/sesions', this.datoSesion)
          swal("Correcto!", "Sesion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoSesion={}
      this.titulo   = 'Crear Sesiones'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idSesion){
      this.modalWindow = true
      if(idSesion != null){    
           api.get('/vwsesions/'+idSesion).then(resp=>{
          this.datoSesion = resp.data;
           });
      }
      this.titulo   = 'Editar Sesiones'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarSesion(){
      this.$router.push('/Sesion')
    },
// Procedimientos master
// Procedimientos detalle
    async getAccesoSesions() {
      const resp = await api.get('/accesosesions')
      this.accesosesions = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.accesosesions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwaccesosesions/nombre/'+this.nombreBusqueda).then(response=>{
          this.accesosesions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.accesosesions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwaccesosesions').then(response=>{
      this.accesosesions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.accesosesions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoAccesoSesion.idSesion === ''){
        swal("Error!", "El elemento idSesion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.idUsuario === ''){
        swal("Error!", "El elemento idUsuario no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.direccionIp === ''){
        swal("Error!", "El elemento direccionIp no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.userAgent === ''){
        swal("Error!", "El elemento userAgent no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarAccesoSesion(){
      if(this.validarForm() === 1){
        try {
          this.datoAccesoSesion.idSesion = this.datoSesion.idSesion;
          await api.post('/accesosesions', this.datoAccesoSesion)
          this.getAccesoSesions();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AccesoSesion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAccesoSesion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/accesosesions', this.datoAccesoSesion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AccesoSesion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAccesoSesion={}
      this.titulo   = 'Crear Sesiones'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAccesoSesion){
      this.modalWindow = true
      if(idAccesoSesion != null){    
           api.get('/vwaccesosesions/'+idAccesoSesion).then(resp=>{
          this.datoAccesoSesion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Sesiones'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAccesoSesion){
      this.modalWindow = true
      if(idAccesoSesion != null){
        this.$router.push('/accesosesionmd/'+idAccesoSesion)
      }
    },
    async deleteAccesoSesion (idAccesoSesion) {
      try{
        await api.delete('/accesosesions/'+idAccesoSesion)
          this.getAccesoSesions()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataAccesoSesionLOVdet(data) {
      this.datoAccesoSesion.idAccesoSesion = data.idAccesoSesion;
      this.datoAccesoSesion.accesoSesion = data.nombre;
    },
//    Lista de Valores
    GetDataModuUsuaLOVdet(data) {
      this.datoAccesoSesion.idModuUsua = data.idModuUsua;
      this.datoAccesoSesion.moduUsua = data.nombre;
    },
// Listas de valores details
  },
}
</script>
